import React, { useState, useEffect, useCallback } from 'react';
import mapboxgl from 'mapbox-gl'
import { DataFeature, SourceForMap, dataForSource } from './map_settings';

import './map.css';

export default function ({ type, action, actionLabel, elementStylePosition, geoLocation, extraInfo, garagesOnMap, addClass }) {
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);
  const [button, setButton] = useState();


  const buildFeaturesForSource = useCallback((data) => {
    let features = [];

    for (const garageID in data) {
      if (data.hasOwnProperty(garageID)) {
        const garage = data[garageID];
        const newFeature = DataFeature(garage.coordinates.longitude, garage.coordinates.latitude, garage.address, garage.secondLine, garage.imageUrl, garage.rotateA, garage.PageLink);
        features = [...features, newFeature];
      }
    }

    return features;
  }, [])


  useEffect(() => {
    if (geoLocation) {
      if (map) {
        map.easeTo({
          duration: 1000,
          center: [geoLocation.longitude, geoLocation.latitude],
          animate: false,
          essential: true
        });

        if (marker) {
          marker.setLngLat([geoLocation.longitude, geoLocation.latitude]);
        }
      }
    }
  }, [geoLocation, map, marker]);

  useEffect(() => {
    if (map) {
      if (garagesOnMap) {
        if (map.hasImage('garage')) {
          const sourse = map.getSource('garages');
          console.log('Source', sourse);
          const newData = dataForSource();
          const features = buildFeaturesForSource(garagesOnMap);

          newData.features = features;

          console.log('NewData', JSON.stringify(newData, null, 2));

          sourse.setData(newData);

        } else {
          map.loadImage('assets/Images/garageIcon.png', (error, image) => {
            if (error) throw error;

            map.addImage('garage', image);

            const source = SourceForMap();
            const data = dataForSource();
            const features = buildFeaturesForSource(garagesOnMap);

            data.features = features;
            data.properties = garagesOnMap.properties;
            source.data = data;

            map.addSource('garages', source);

            map.addLayer({
              'id': 'points',
              'type': 'symbol',
              'source': 'garages',
              'layout': {
                'icon-image': 'garage',
                'icon-size': 1
              }
            });

            // Add popup on click
            map.on('click', 'points', (e) => {
              const coordinates = e.features[0].geometry.coordinates.slice();
              const properties = e.features[0].properties;
              // Create popup
              new mapboxgl.Popup()
                .setLngLat(coordinates)
                .setHTML(`<a target="blank" href=garages-details/${properties.PageLink}>
                <img src='${properties.imageUrl}'
                 style='width:100%;height:200px;transform:rotate(${properties.rotateA}deg)'
                 >
                <h5 class="text-primary text-center">${properties.description}</h5>
                <span>${properties.secondLine}</span>`)
                .addTo(map);
            });
            const myArray = Object.values(garagesOnMap);

            const allbounds = [];

            let bounds = new mapboxgl.LngLatBounds();
            if (myArray && myArray.length > 0) {
              myArray.forEach(garage => {
                const longitude = parseFloat(garage.coordinates.longitude);
                const latitude = parseFloat(garage.coordinates.latitude);
                if (!isNaN(longitude) && !isNaN(latitude)) {
                  allbounds.push([garage.coordinates.longitude, garage.coordinates.latitude]);
                  bounds.extend([longitude, latitude]);
                } else {
                  console.warn('Invalid coordinates for garage:', garage);
                }
              });



              if (allbounds.length > 0) {
                // Construct a LngLatBounds object from allbounds
                let lngLatBounds = new mapboxgl.LngLatBounds();
                allbounds.forEach(coords => {
                  lngLatBounds.extend(coords);
                });

                // console.log('lngLatBounds:', lngLatBounds);
                if (allbounds.length > 1) {
                  map.fitBounds(lngLatBounds, { padding: 100 });
                } else {
                  map.fitBounds(lngLatBounds, { padding: 1000 });
                }


              }

            }
            // Change the cursor to a pointer when hovering over the points layer.
            map.on('mouseenter', 'points', () => {
              map.getCanvas().style.cursor = 'pointer';
            });

            // Change it back to a pointer when it leaves.
            map.on('mouseleave', 'points', () => {
              map.getCanvas().style.cursor = '';
            });
          });
        }
      }
    }
  }, [garagesOnMap, map, buildFeaturesForSource])

  useEffect(() => {
    mapboxgl.accessToken = 'pk.eyJ1IjoiZG5sc2FsYXphciIsImEiOiJjazlhanAzMGgwNmZoM2ZxcjFubmZyNDQ5In0.vWx_BcKUVet4mGXu6dcexA';

    switch (type) {
      case 'position_selector': {
        const MapSettings = {
          container: 'map',
          style: 'mapbox://styles/mapbox/streets-v11',
          zoom: 11.2,
          minZoom: 0,
          maxZoom: 0,
          center: [-73.97550875532467, 40.78447898127882],
          maxPitch: 60,
          pitch: 0,
          bearing: 0,
        }

        const newMap = new mapboxgl.Map(MapSettings);
        const nav = new mapboxgl.NavigationControl();
        newMap.addControl(nav, 'bottom-right');

        const marker = new mapboxgl.Marker({
          draggable: true,
          color: "#ff0909",
        }).setLngLat([-73.97550875532467, 40.78447898127882])
          .addTo(newMap);

        function handleActionClick() {
          if (action) {
            action(marker.getLngLat());
          } else {
            console.log('Action for map is not defined');
          }
        }

        newMap.on("click", (e) => {
          const coors = e.lngLat;
          marker.setLngLat([coors.lng, coors.lat]);
          console.log('latlng', coors.lng, coors)
        });

        setMarker(() => marker);

        setButton(() => (
          <span className='map__button la la-check-circle' onClick={handleActionClick}></span>
        ));
        setMap(() => newMap);
        break;
      }


      case 'no_pointer': {
        const MapSettings = {
          container: 'map',
          style: 'mapbox://styles/mapbox/streets-v11',
          zoom: 6,
          minZoom: 0,
          maxZoom: 0,
          center: [-73.97550875532467, 40.78447898127882],
          maxPitch: 60,
          pitch: 0,
          bearing: 0,
        }

        const newMap = new mapboxgl.Map(MapSettings);
        const nav = new mapboxgl.NavigationControl();
        newMap.addControl(nav, 'bottom-right');

        newMap.on("click", (e) => {
          const coors = e.lngLat;
          marker.setLngLat([coors.lng, coors.lat]);
          console.log("coors", coors)
        });
        setMap(() => newMap);
        break;
      }

      case 'regular': {
        break;
      }


      case 'position_selector_edit': {
        const MapSettings = {
          container: 'map',
          style: 'mapbox://styles/mapbox/streets-v11',
          zoom: 12,
          minZoom: 0,
          maxZoom: 0,
          center: [-73.97550875532467, 40.78447898127882],
          maxPitch: 60,
          pitch: 0,
          bearing: 0,
        }
        const newMap = new mapboxgl.Map(MapSettings);
        const nav = new mapboxgl.NavigationControl();
        newMap.addControl(nav, 'bottom-right');

        const marker = new mapboxgl.Marker({
          draggable: true,
          color: "#ff0909",
        }).setLngLat([-73.97550875532467, 40.78447898127882])
          // .setLngLat([extraInfo.coordinates.longitude, extraInfo.coordinates.latitude])
          .addTo(newMap);

        function handleActionClick() {
          if (action) {
            action(marker.getLngLat());
          } else {
            console.log('Action for map is not defined');
          }
        }

        newMap.on("click", (e) => {
          const coors = e.lngLat;
          marker.setLngLat([coors.lng, coors.lat]);
        });


        setMarker(() => marker);
        //console.log(extraInfo)

        setButton(() => (
          <span className='map__button la la-map-marker' onClick={handleActionClick}>{actionLabel ? actionLabel : 'add_task'}</span>
        ));


        if (extraInfo && extraInfo.coordinates && extraInfo.coordinates.longitude) {
          marker.setLngLat([extraInfo.coordinates.longitude, extraInfo.coordinates.latitude]);

          newMap.setCenter([extraInfo.coordinates.longitude, extraInfo.coordinates.latitude]);
        }
        setMap(() => newMap);
        break;
      }

      case 'point': {
        console.log('extraInfoextraInfo', extraInfo)
        const MapSettings = {
          container: 'map',
          style: 'mapbox://styles/mapbox/streets-v11',
          zoom: 13,
          center: [extraInfo.coordinates.longitude, extraInfo.coordinates.latitude],
          maxPitch: 60,
          pitch: 0,
          bearing: 0,
        }
        const Multiplepointer = new mapboxgl.Map(MapSettings);

        const marker = new mapboxgl.Marker({
          draggable: false,
          zoom: 9,
          color: "#ff0909",
        }).setLngLat([extraInfo.coordinates.longitude, extraInfo.coordinates.latitude])
          .addTo(Multiplepointer);

        setMarker(() => marker);
        if (extraInfo) {
          setButton(() => (
            <span className='map__button map__address'>{extraInfo.address}</span>
          ));

          marker.setLngLat([extraInfo.coordinates.longitude, extraInfo.coordinates.latitude]);

          Multiplepointer.setCenter([extraInfo.coordinates.longitude, extraInfo.coordinates.latitude]);
        }
        setMap(() => Multiplepointer);
        break;
      }

      case 'multiple_pointers': {
        const MapSettings = {
          container: 'map',
          style: 'mapbox://styles/mapbox/streets-v11',
          zoom: 11,
          center: [-73.97550875532467, 40.78447898127882]
        }

        const Multiplepointer = new mapboxgl.Map(MapSettings);
        if (geoLocation) {
          if (extraInfo) {
            Multiplepointer.on('load', () => {
              Multiplepointer.addSource('source_circle_500', {
                'type': 'geojson',
                'data': JSON.parse(extraInfo)
              });


              Multiplepointer.addLayer({
                'id': 'circle500',
                'type': 'fill',
                'source': 'source_circle_500',
                "layout": {
                  // "visibility": "none"
                },
                "paint": {
                  'fill-color': '#0080ff',
                  'fill-opacity': 0.2,
                }
              });
              Multiplepointer.addLayer({
                'id': 'outline',
                'type': 'line',
                'source': 'source_circle_500',
                'layout': {},
                'paint': {
                  'line-color': '#000',
                  'line-width': 1
                }
              });
            });
          }
        }
        setMap(() => Multiplepointer);
        break;

      }
      default:
        break;
    }

  }, [action, actionLabel, type, elementStylePosition, extraInfo, geoLocation]);

  return (
    <div className={`fullwidth-home-map ${addClass ? addClass : ''}  map__element_container${elementStylePosition ? `--${elementStylePosition}` : ''}`} id="map-container">
      <div id='map' className='map__container'></div>
      {button && button}
    </div>
  )
}